import { SOCKET_EVENTS } from '@witmetrics/utils/constants';
import type { IsReadFilter, Notification } from '@witmetrics/utils';
import type { EnhancedDispatch } from '@witmetrics/data-store';
import type { Subscribe } from '@/types/sockets';

const {
  NEW_NOTIFICATION,
  UPDATE_NOTIFICATION,
  UPDATE_ALL_NOTIFICATIONS,
  DELETE_NOTIFICATION,
  DELETE_ALL_NOTIFICATIONS,
} = SOCKET_EVENTS;

export function subscribeNotifications(
  dispatch: EnhancedDispatch,
  subscribe: Subscribe
) {
  subscribe({
    endpoint: NEW_NOTIFICATION,
    callback: (data: { unreadCount: number; notification: Notification }) => {
      dispatch.addNotifications([data.notification]);
      dispatch.setUnreadNotificationsCount(data.unreadCount);
    },
  });
  subscribe({
    endpoint: UPDATE_NOTIFICATION,
    callback: (data: {
      unreadCount: number;
      notification: { notificationId: number; isRead: boolean };
    }) => {
      dispatch.updateNotification(data.notification);
      dispatch.setUnreadNotificationsCount(data.unreadCount);
    },
  });
  subscribe({
    endpoint: UPDATE_ALL_NOTIFICATIONS,
    callback: (data: { unreadCount: number; isRead: boolean }) => {
      dispatch.updateAllNotifications({ isRead: data.isRead });
      dispatch.setUnreadNotificationsCount(data.unreadCount);
    },
  });
  subscribe({
    endpoint: DELETE_NOTIFICATION,
    callback: (data: { unreadCount: number; notificationId: number }) => {
      dispatch.deleteNotification({ notificationId: data.notificationId });
      dispatch.setUnreadNotificationsCount(data.unreadCount);
    },
  });
  subscribe({
    endpoint: DELETE_ALL_NOTIFICATIONS,
    callback: (data: { unreadCount: number; filter?: IsReadFilter }) => {
      dispatch.deleteAllNotifications({ filter: data.filter });
      dispatch.setUnreadNotificationsCount(data.unreadCount);
    },
  });
}
